export { ArrowLeft as default } from './ArrowLeft';
